import { computed } from "vue";
import { useStore } from "vuex";
import { useItemsConditions } from "@/composables/useItemsConditions";
import { isPortalTenantEligibleForHome } from "@/router/portalHomeAccess";

export function usePortalPurchaseDetailsLink() {
  const store = useStore();
  const { canSeePointsInfo } = useItemsConditions();

  const canOpenPurchaseDetails = computed(() => {
    if (isPortalTenantEligibleForHome()) {
      const roles = store.getters.getMe?.roles?.map((role) => role.name) ?? [];
      return roles.includes("dealer");
    }

    return canSeePointsInfo();
  });

  return { canOpenPurchaseDetails };
}
